import { colors } from './../../../../../config/styles'

export default {
	formTitle: {
		textAlign: 'center',
		color: colors.primary,
		fontWeight: 300,
	},
}
